import { Typography } from '@mui/material';
import { Row } from 'further-ui/components/Layout';
import BulkRevaluationsStepper from './BulkRevaluationsStepper';
import CloseButton from 'components/new/FullPageDrawer/CloseButton';

type Props = {
  title: string;
  onClose: () => void;
  activeStep?: number;
};

const BulkRevaluationsDrawerTitle: React.FC<Props> = ({
  title,
  activeStep,
  onClose,
}) => (
  <Row centered fullWidth spacing="xs">
    <Row centered fullWidth justify="space-between" spacing="xs">
      <Typography variant="h4">{title}</Typography>
      {activeStep !== undefined && (
        <BulkRevaluationsStepper activeStep={activeStep} />
      )}
    </Row>
    <CloseButton onClose={onClose} />
  </Row>
);

export default BulkRevaluationsDrawerTitle;
